import React, { useEffect, useMemo, useState } from 'react';
import { useDesignTheme } from '../design/DesignThemeContext';

function countThisYear(reports) {
  const year = new Date().getFullYear();
  return reports.filter(report => {
    const raw = report.estimatedIncidentTime || report.created_at || report.createdAt;
    if (!raw) {
      return false;
    }
    const date = new Date(raw);
    return !Number.isNaN(date.getTime()) && date.getFullYear() === year;
  }).length;
}

function AnimatedCount({ value }) {
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setDisplay(value);
      return undefined;
    }

    let frame;
    const start = performance.now();
    const duration = 500;

    const tick = now => {
      const progress = Math.min((now - start) / duration, 1);
      setDisplay(Math.round(value * progress));
      if (progress < 1) {
        frame = requestAnimationFrame(tick);
      }
    };

    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, [value]);

  return <span className="swarm-corridor-stats__value">{display}</span>;
}

export default function CorridorStatsStrip({ reports = [], onOpenStatistics }) {
  const { isCorridor, copy } = useDesignTheme();
  const total = reports.length;
  const thisYear = useMemo(() => countThisYear(reports), [reports]);

  if (!isCorridor) {
    return null;
  }

  const ctaLabel = copy.statisticsStripCta || copy.reportStatistics;
  const ctaDetail = copy.statisticsStripDetail;

  return (
    <button
      type="button"
      className="swarm-corridor-stats mb-6"
      data-testid="corridor-stats-strip"
      onClick={onOpenStatistics}
      aria-label={`${ctaLabel}. ${total} total reports, ${thisYear} this year.`}
    >
      <div className="swarm-corridor-stats__summary">
        <span>
          <AnimatedCount value={total} /> total reports
        </span>
        <span className="swarm-corridor-stats__divider" aria-hidden="true">
          ·
        </span>
        <span>
          <AnimatedCount value={thisYear} /> this year
        </span>
        <span className="swarm-corridor-stats__divider" aria-hidden="true">
          ·
        </span>
        <span>Murray Road corridor</span>
      </div>
      <div className="swarm-corridor-stats__cta">
        <span className="swarm-corridor-stats__cta-label">
          {ctaLabel}
          <span className="swarm-corridor-stats__cta-arrow" aria-hidden="true">
            →
          </span>
        </span>
        {ctaDetail && <span className="swarm-corridor-stats__cta-detail">{ctaDetail}</span>}
      </div>
    </button>
  );
}
